/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface GovernanceCustomQuestionnaire
 */
export interface GovernanceCustomQuestionnaire {
  /**
   *
   * @type {number}
   * @memberof GovernanceCustomQuestionnaire
   */
  readonly id: number;
  /**
   *
   * @type {string}
   * @memberof GovernanceCustomQuestionnaire
   */
  name: string;
}

/**
 * Check if a given object implements the GovernanceCustomQuestionnaire interface.
 */
export function instanceOfGovernanceCustomQuestionnaire(value: object): value is GovernanceCustomQuestionnaire {
  if (!('id' in value) || value['id'] === undefined) return false;
  if (!('name' in value) || value['name'] === undefined) return false;
  return true;
}

export function GovernanceCustomQuestionnaireFromJSON(json: any): GovernanceCustomQuestionnaire {
  return GovernanceCustomQuestionnaireFromJSONTyped(json, false);
}

export function GovernanceCustomQuestionnaireFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): GovernanceCustomQuestionnaire {
  if (json == null) {
    return json;
  }
  return {
    id: json['id'],
    name: json['name'],
  };
}

export function GovernanceCustomQuestionnaireToJSON(value?: Omit<GovernanceCustomQuestionnaire, 'id'> | null): any {
  if (value == null) {
    return value;
  }
  return {
    name: value['name'],
  };
}
